<template>
  <v-container grid-list-xs>
    <v-app-bar app elevate-on-scroll v-if="$vuetify.breakpoint.smAndUp">
      <v-img :src="theme.logoImgUrl"
        contain aspect-ratio="1.2" max-width="400" max-height="40" />
      <div class="d-flex">
        <mb-text-button name="reg_presentation" label="Apresentação" text
          @click="presentation" />
        <mb-text-button name="reg_benefits" label="Benefícios" text
          @click="benefits" />
        <mb-text-button name="reg_contact" label="Contato" text
          @click="benefits" />
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <mb-text-button name="reg_access" label="Acessar" outlined @click="login" />
      </div>
    </v-app-bar>

    <v-app-bar app elevate-on-scroll v-else>
      <v-img
        :src="theme.logoImgUrl"
        contain
        aspect-ratio="1.2"
        max-width="350"
        max-height="35"
        v-if="!drawer"
      ></v-img>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary right app overflow>
      <v-list>
        <v-list-item-content @click="presentation">
          <v-img
            :src="theme.logoImgUrl"
            contain
            aspect-ratio="1.2"
            max-width="350"
            max-height="35"
          ></v-img>
        </v-list-item-content>
        <v-divider></v-divider>
        <v-list-item-content @click="login" class="pa-3">
          <v-list-item-title class="title" v-text="'Acessar'" />
        </v-list-item-content>
        <v-list-item-content @click="presentation" class="pa-3">
          <v-list-item-title v-text="'Apresentação'" />
        </v-list-item-content>
        <v-list-item-content @click="presentation" class="pa-3">
          <v-list-item-title v-text="'Benefícios'" />
        </v-list-item-content>
        <v-list-item-content @click="presentation" class="pa-3">
          <v-list-item-title v-text="'Contato'" />
        </v-list-item-content>
      </v-list>
    </v-navigation-drawer>

    <register-form @registered="registeredOk = true" v-if="!registeredOk"/>

    <v-row justify="center" >
      <v-col xl="4" lg="4" md="4" sm="5" cols="12">
        <verification-form v-if="registeredOk" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import RegisterForm from '@/components/register/RegisterForm';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import VerificationForm from '@/components/register/VerificationForm';

export default {
  data: () => ({
    drawer: false,
    registeredOk: false,
  }),
  computed: {
    theme() {
      return this.$store.getters['poweredBy/theme'];
    },
  },
  methods: {
    login() {
      this.$router.push({ path: '/login' });
    },
    presentation() {
      location.href = `${process.env.VUE_APP_PATH_PGS_MB}/patient/loading-page/index#apresentacao`;
    },
    benefits() {
      location.href = `${process.env.VUE_APP_PATH_PGS_MB}/patient/loading-page/index#beneficios`;
    },
    contact() {
      location.href = `${process.env.VUE_APP_PATH_PGS_MB}/patient/loading-page/index#contato`;
    },
  },
  components: {
    RegisterForm,
    VerificationForm,
    MbTextButton,
  },
};
</script>
